import React from "react";
import { useNavigate } from "react-router-dom";
import { Routes } from "~/routes";
import { useAuth } from "@components/auth-provider/AuthProvider";

export interface UnauthenticatedRouteProps {
  children: React.ReactNode;
}

/**
 * This wrapper component ensures a page can only be viewed if the user is not authenticated.
 */
const UnauthenticatedRoute: React.FC<UnauthenticatedRouteProps> = (props) => {
  const auth = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (auth.loaded && auth.isAuthenticated) {
      navigate(Routes.Home, { replace: true });
    }
  }, [auth.loaded, auth.isAuthenticated, navigate]);

  if (!auth.loaded) {
    // Show the page while we validate any stored token.
    return <>{props.children}</>;
  }

  if (auth.isAuthenticated) {
    return <></>;
  }

  return <>{props.children}</>;
};

export default UnauthenticatedRoute;
